// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";

// Configuración de los temas predeterminados
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light", // Usar el tema `light` por defecto
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#F5F7FA", // fondo gris muy claro, neutral
          surface: "#FFFFFF",
          primary: "#046FFA", // azul principal
          secondary: "#044B93", // azul profundo
          accent: "#707275", // gris neutro
          error: "#D32F2F", // rojo alerta
          info: "#0288D1", // azul información
          success: "#2E7D32", // verde éxito
          warning: "#F9A825", // amarillo advertencia
        },
      },
      dark: {
        dark: true,
        colors: {
          background: "#121212", // gris oscuro profundo
          surface: "#1E1E1E",
          primary: "#046FFA",
          secondary: "#044B93",
          accent: "#A0A0A0", // gris claro visible sobre fondo oscuro
          error: "#EF5350",
          info: "#29B6F6",
          success: "#66BB6A",
          warning: "#FFCA28",
        },
      },
    },
  },
});

export default vuetify;
